import React, { FC } from "react";

import { SettingsConfirmModal } from "../../../components/modal/SettingsConfirmModal";
import { WarningExclaimSvg } from "../../../components/svg/WarningExclaimSvg";

type Props = {
  contactName: string;
  isActive: boolean;
  isLoading?: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

const ITEM_TYPE = "Contact";

const getAction = (isActive: boolean): "Archive" | "Activate" =>
  isActive ? "Archive" : "Activate";

const getContactStatusTitle = (action: string, contactName: string): string => {
  const trimmedContactName = contactName.trim();

  if (!trimmedContactName) {
    return `${action} ${ITEM_TYPE}?`;
  }

  return `${action} '${trimmedContactName}' ${ITEM_TYPE}?`;
};

export const ContactStatusConfirmModal: FC<Props> = ({
  contactName,
  isActive,
  isLoading,
  onClose,
  onConfirm,
}) => {
  const action = getAction(isActive);

  return (
    <SettingsConfirmModal
      onClose={onClose}
      onConfirm={onConfirm}
      icon={<WarningExclaimSvg sizeCx={"h-6 w-6"} />}
      title={getContactStatusTitle(action, contactName)}
      description={`Are you sure you want to ${action.toLowerCase()} this contact?`}
      confirmText={action}
      variant={"warning"}
      isLoading={isLoading}
    />
  );
};
